import { render, staticRenderFns } from "./SerialField.vue?vue&type=template&id=a776a100&scoped=true"
import script from "./SerialField.vue?vue&type=script&lang=js"
export * from "./SerialField.vue?vue&type=script&lang=js"
import style0 from "./SerialField.vue?vue&type=style&index=0&id=a776a100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a776a100",
  null
  
)

export default component.exports